window.ttx = window.ttx || {};

let db = '';
ttx.indexedDB = {};
ttx.indexedDB.dbs = {};

ttx.indexedDB.openDB = async function (dbName, daVer, tables = []) {
    return new Promise((resolve) => {
        const indexedDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.msIndexedDB;
        if (!indexedDB) {
            ttx.console.log('[ttx.indexedDB.openDB]: 当前浏览器不支持IndexedDB');
            resolve(false);
            return;
        }

        let request;
        if ((ttx.utils.isIE && ttx.utils.isIE()) || (ttx.utils.isEdge && ttx.utils.isEdge() && !daVer)) {
            request = indexedDB.open(dbName);
        } else {
            request = indexedDB.open(dbName, daVer);
        }

        request.onsuccess = function (e) {
            db = e.target.result;
            ttx.indexedDB.dbs[dbName] = db;
            ttx.console.log(`[ttx.indexedDB.openDB]: 连接数据库${dbName}成功`);
            db.onclose = function () {
                ttx.console.log('[ttx.indexedDB.openDB]: 数据库意外关闭');
            };
            db.onversionchange = function () {
                ttx.console.log('[ttx.indexedDB.openDB]: 数据库版本发生变化');
            };
            resolve(true);
        };

        request.onerror = function (e) {
            ttx.console.error(`[ttx.indexedDB.openDB]: 连接数据库失败: ${e?.target?.error}`);
            resolve(false);
        };

        request.onblocked = function () {
            ttx.console.log('[ttx.indexedDB.openDB]: 上一次的数据库连接还未关闭');
        };

        request.onupgradeneeded = function (e) {
            db = e.target.result;
            (tables || []).forEach(table => {
                let name = table;
                let keyPath = 'indexedDB_id';
                if (typeof table === 'object') {
                    name = table.name;
                    keyPath = table.keyPath;
                }
                if (!db.objectStoreNames.contains(name)) {
                    if (name === 'offlineLogin' || name === 'metaData' || name === 'billNodata' || keyPath === 'attrKey') {
                        db.createObjectStore(name, { keyPath: 'attrKey' });
                    } else {
                        db.createObjectStore(name, { keyPath: keyPath, autoIncrement: true });
                    }
                }
            });
        };
    });
};

ttx.indexedDB.IDB_saveData = function (data, dbTableName, dbName) {
    return new Promise((resolve, reject) => {
        if (dbName) db = ttx.indexedDB.dbs[dbName];
        if (!db) {
            ttx.console.error(`[ttx.indexedDB.IDB_saveData]: 参数错误, dbName[${dbName}]不存在, dbTableName=${dbTableName}`);
            reject(new Error('db not found'));
            return;
        }
        const name = dbTableName || 'save_data';
        const tx = db.transaction(name, 'readwrite');
        const store = tx.objectStore(name);
        const req = store.put(data);

        req.onsuccess = function (e) {
            ttx.console.log(`[ttx.indexedDB.IDB_saveData]: 成功保存至dbName[${dbName}] dbTableName[${dbTableName}]`);
            resolve(e?.target?.result);
        };
        req.onerror = function (e) {
            ttx.console.log(`[ttx.indexedDB.IDB_saveData]: save fail, error message is ${e?.target?.result}`);
            reject(e?.target?.result);
        };
    });
};

ttx.indexedDB.IDB_saveDatas = function (dataArr, dbTableName, dbName) {
    return new Promise((resolve, reject) => {
        if (!dataArr || !dataArr.length) {
            reject(new Error('数据格式错误'));
            return;
        }
        if (dbName) db = ttx.indexedDB.dbs[dbName];
        if (!db) {
            reject(new Error('db not found'));
            return;
        }
        const name = dbTableName || 'save_data';
        const tx = db.transaction(name, 'readwrite');
        const store = tx.objectStore(name);

        let count = 0;
        for (let i = 0, len = dataArr.length; i < len; i++) {
            const req = store.put(dataArr[i]);
            req.onsuccess = function () {
                count++;
            };
        }

        tx.oncomplete = function () {
            if (count === dataArr.length) {
                ttx.console.log(`[ttx.indexedDB.IDB_saveDatas]: 成功保存多条数据: ${dataArr.length}条`);
                resolve(true);
            } else {
                reject(new Error(`${dataArr.length - count}条保存失败`));
            }
        };

        tx.onerror = function (e) {
            reject(e);
        };
    });
};

ttx.indexedDB.IDB_deleteOneData = function (options = {}) {
    return new Promise(resolve => {
        let { id, dbTableName, dbName } = options;
        if (dbName) db = ttx.indexedDB.dbs[dbName];
        if (!db) {
            ttx.console.warn(`[ttx.indexedDB.IDB_deleteOneData]: 参数错误, dbName[${dbName}]不存在`);
            resolve('删除成功');
            return;
        }

        dbTableName = dbTableName || 'save_data';
        const tx = db.transaction(dbTableName, 'readwrite');
        const store = tx.objectStore(dbTableName);
        const req = store.delete(id);

        req.onsuccess = function () {
            resolve('删除成功');
        };
        req.onerror = function () {
            resolve('删除失败');
        };
    });
};

ttx.indexedDB.IDB_deleteSomeData = function (options = {}) {
    return new Promise(resolve => {
        let { id, dbTableName, dbName } = options;
        if (dbName) db = ttx.indexedDB.dbs[dbName];
        if (!db) {
            ttx.console.error(`[ttx.indexedDB.IDB_deleteSomeData]: 参数错误, dbName[${dbName}]不存在`);
            resolve('删除失败');
            return;
        }

        dbTableName = dbTableName || 'save_data';
        const tx = db.transaction(dbTableName, 'readwrite');
        const store = tx.objectStore(dbTableName);

        if (Array.isArray(id) && id.length > 0) {
            for (let i = 0; i < id.length; i++) {
                const req = store.delete(id[i]);
                req.onsuccess = function () {
                    ttx.console.log(`[ttx.indexedDB.IDB_deleteSomeData]: 删除id=${id[i]}成功`);
                };
                req.onerror = function (e) {
                    ttx.console.error(`[ttx.indexedDB.IDB_deleteSomeData]: 删除id=${id[i]}失败: ${e?.target?.result?.error}`);
                };
            }
        }

        tx.oncomplete = function () {
            resolve('删除成功');
        };
        tx.onerror = function () {
            resolve('删除失败');
        };
    });
};

ttx.indexedDB.IDB_searchData = function (options = {}) {
    const { onlyCheck, dbTableName, dbName } = options;
    return new Promise((resolve, reject) => {
        if (dbName) db = ttx.indexedDB.dbs[dbName];
        if (!db) {
            ttx.console.error(`[ttx.indexedDB.IDB_searchData]: 参数错误, dbName[${dbName}]不存在`);
            resolve([]);
            return;
        }

        const name = dbTableName || 'save_data';
        const tx = db.transaction(name, 'readonly');
        const store = tx.objectStore(name);
        const range = IDBKeyRange.lowerBound(1);
        const req = store.openCursor(range, 'next');
        const dbData = [];

        req.onsuccess = function () {
            const cursor = this.result;
            if (cursor) {
                if (onlyCheck) {
                    dbData.push(cursor.value);
                    resolve(dbData);
                    return;
                }
                dbData.push(cursor.value);
                cursor.continue();
            } else {
                resolve(dbData);
            }
        };

        req.onerror = function (e) {
            reject(e?.target?.result);
        };
    });
};

ttx.indexedDB.IDB_getData = function (options = {}) {
    return new Promise((resolve, reject) => {
        const { key, dbTableName, dbName } = options;
        if (dbName) db = ttx.indexedDB.dbs[dbName];
        if (!db) {
            ttx.console.error(`[ttx.indexedDB.IDB_getData]: 参数错误, dbName[${dbName}]不存在`);
            resolve();
            return;
        }

        const tx = db.transaction(dbTableName, 'readonly');
        const store = tx.objectStore(dbTableName);
        const req = store.get(key);

        req.onsuccess = function (e) {
            resolve(e.target.result);
        };
        req.onerror = function (e) {
            reject(e.target.result);
        };
    });
};

ttx.indexedDB.IDB_getDatas = function (options = {}) {
    return new Promise((resolve, reject) => {
        const { key, dbTableName, dbName } = options;
        if (!key || !key.length) {
            reject(new Error('数据格式错误'));
            return;
        }
        if (dbName) db = ttx.indexedDB.dbs[dbName];
        if (!db) {
            reject(new Error('db not found'));
            return;
        }

        const tx = db.transaction(dbTableName, 'readonly');
        const store = tx.objectStore(dbTableName);

        const returnData = [];
        for (let i = 0, len = key.length; i < len; i++) {
            const req = store.get(key[i]);
            req.onsuccess = function (e) {
                returnData.push(e.target.result);
            };
        }

        tx.oncomplete = function () {
            if (returnData.length === key.length) {
                resolve(returnData);
            } else {
                reject(new Error(`${key.length - returnData.length}条数据读取失败`));
            }
        };

        tx.onerror = function (e) {
            reject(e);
        };
    });
};

ttx.indexedDB.IDB_tableClear = function (dbTableName, dbName) {
    return new Promise((resolve) => {
        if (dbName) db = ttx.indexedDB.dbs[dbName];
        if (!db) {
            ttx.console.error(`[ttx.indexedDB.IDB_tableClear]: 参数错误, dbName[${dbName}]不存在`);
            resolve(false);
            return;
        }
        if (!dbTableName) {
            resolve(false);
            return;
        }

        const tx = db.transaction(dbTableName, 'readwrite');
        const store = tx.objectStore(dbTableName);
        const req = store.clear();

        req.onsuccess = function () {
            resolve(`清除${dbTableName}表全部数据成功`);
        };
        req.onerror = function () {
            ttx.console.error(`[ttx.indexedDB.IDB_tableClear]: 清除${dbTableName}表全部数据失败`);
            resolve(false);
        };
    });
};
